import React from 'react';

/**
 * DropDown divider
 */
const DropDownDivider = () => (<li className="bi-dd-divider" />);

export default React.memo(DropDownDivider);
